// extracted by mini-css-extract-plugin
export default {"button_area":"MyButtonSquare_button_area__4Qi7r","link":"MyButtonSquare_link__21V+9"};